import { render, staticRenderFns } from "./myAddrMsg.vue?vue&type=template&id=2e6636ae&scoped=true"
import script from "./myAddrMsg.vue?vue&type=script&lang=js"
export * from "./myAddrMsg.vue?vue&type=script&lang=js"
import style0 from "./myAddrMsg.vue?vue&type=style&index=0&id=2e6636ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6636ae",
  null
  
)

export default component.exports